export default __webpack_public_path__ + "static/section-pattern-eea4201309a5b3ad80ecc44142c653af.svg";